export const VALOR_GUION = '-';
